import { render, staticRenderFns } from "./news-list.vue?vue&type=template&id=65cf5024&scoped=true&"
import script from "./news-list.vue?vue&type=script&lang=ts&"
export * from "./news-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cf5024",
  null
  
)

export default component.exports